module.exports = __webpack_public_path__ + "static/media/05_tn.deb7da10.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/monuments/brownandgray/thumbnails/05_tn.jpg
// module id = 314
// module chunks = 0